import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { useShallow } from 'zustand/react/shallow';
import {
  DropDownSelector,
  Checkbox,
  SelectExecutor,
  ButtonClose,
  InputDinamycPlaceholder,
  SceletonSelectGroups,
  NoDataContent
} from '@lk-gtcom/ecomlab-components';
import { Editor } from '../../../components/Editor/Editor';
import { DateBox } from '../../../components/DateBox/DateBox';
import { ChatComment } from '../ChatTask/ChatComment';
import { AuthorAvatar } from '../../ArticleComponents/AuthorAvatar/AuthorAvatar';
import { ButtonCopy } from '../../../components/Buttons/ButtonCopy/ButtonCopy';
import { CheckList } from '../../../components/CheckList/CheckList';
import { TabsGreen } from '../../../components/TabsGreen/TabsGreen';
import { FileItemComponent } from '../../../components/FileItemComponent/FileItemComponent';
import { ButtonActionDrop } from '../../../components/Buttons/ButtonActionDrop/ButtonActionDrop';
import { ModalAddTaskExit } from '../Modal/ModalAddTaskExit/ModalAddTaskExit';
import { PrintableVersion } from '../PrintableVersion/PrintableVersion';
import TitleContentEditable from './test/TitleContentEditable';
import { TitlePage } from '../../../components/TitlePage/TitlePage';
import { DynamicFormComponent } from '../../../components/DynamicFormComponent/DynamicFormComponent';
import { ButtonWithIcon } from '../../../components/Buttons/ButtonWithIcon/ButtonWithIcon';
import SaveIndicator from '../SaveIndicator/SaveIndicator';
import HistoryTask from '../HistoryTask/HistoryTask';
import CompanyCard from './CompanyCard/CompanyCard';
import ContactCard from './ContactCard/ContactCard';
import { usePushNotifications } from '../../../common/pushNotification';
import customHeaders, { getSpace } from '../../../common/headers';
import useGeneralStore from '../../../store/general';
import { RavshanHttps } from '../../../fetchUrls';
import './ModalAddTask.scss';

// Иконки
import low_status from './img/low_status.svg';
import hight_status from './img/hight_status.svg';
import medium_status from './img/medium_status.svg';
import add_icon from './img/add.svg';
import copy_icon from './img/copy_icon.svg';
import print_icon from './img/print_icon.svg';
import drop_icon from './img/drop_icon.svg';

const parse = require('html-react-parser');

export const OPTIONS_PRIORITY = [
  {
    label: (
      <span style={{ color: '#E62E2E' }}>Высокий</span>
    ),
    value: 'Высокий',
    icon: hight_status
  },
  {
    label: (
      <span style={{ color: '#EE9023' }}>Средний</span>
    ),
    value: 'Средний',
    icon: medium_status
  },
  {
    label: (
      <span style={{ color: '#26AF33' }}>Низкий</span>
    ),
    value: 'Низкий',
    icon: low_status
  },
  {
    label: 'Не указано',
    value: 'Не назначено',
  },
];

export const PRIORITY_TO_COLOR_MAP = {
  Низкий: '#26AF33',
  Средний: '#EE9023',
  Высокий: '#E62E2E',
  'Не назначено': 'blue',
};

const colors = {
  'на стопе': '#F1893F',
  'в работе': '#DC17D4',
  'на проверке': '#8F43F0',
  'готово': '#08C104',
  'новые задачи': '#6574FF',
};

const convertDate = (dateString) => {
  if (!dateString) return null;

  // Если дата уже в ISO формате
  if (dateString.includes('T')) {
    return dateString;
  }

  // Если формат "DD-MM-YYYY HH:MM:SS"
  const [datePart, timePart] = dateString.split(' ');
  if (!datePart || !timePart) return dateString;

  const [day, month, year] = datePart.split('-');
  return `${year}-${month}-${day}T${timePart}:00.000Z`;
};


const ModalAddTask = ({
  setIsModal,
  infoTask = false,
  attendees,
  setInfoTask,
  setTasks,
  selectedColumn,
  allColumns,
  fetchDeleteTask,
  taskId,
  query,
  isLoadInfoTask,
  isNew,
  setIsNew,
  event_id,
  setUpdateId,
  setActualId,
  ticket = false,
  crm = false,
  task = false
}) => {
  const {
    isModalCompany,
    setIsModalCompany,
    isModalContact,
    setIsModalContact,
    setCurrentDeal
  } = useGeneralStore(
    useShallow((state) => ({
      isModalCompany: state.isModalCompany,
      setIsModalCompany: state.setIsModalCompany,
      isModalContact: state.isModalContact,
      setIsModalContact: state.setIsModalContact,
      currentDeal: state.currentDeal,
      setCurrentDeal: state.setCurrentDeal
    }))
  );

  const [count, setCount] = useState({});

  // Параметр для запросов
  const cur_param_id = (param) => {
    if (crm) return 'deal_id'
    if (task) return 'event_id'
    if (ticket) return 'ticket_id'
  }

  const btns_2 = [
    { label: 'Комментарии', value: 'comment', count: count?.comments },
    { label: 'Чек-лист', value: 'task-list', count: count?.task_list },
    ...(crm || task) ?
      [
        { label: 'Файлы', value: 'file', count: count?.files },
        { label: 'История', value: 'history', count: count?.logs }
      ]
      :
      []
  ];

  // Обработка ошибок
  const { addErrorPush, addSuccessPush } = usePushNotifications();

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const email = localStorage.getItem('email')
  const client_id = +localStorage.getItem('client_id')

  const [endDate, setEndDate] = useState(new Date());
  const [endDate2, setEndDate2] = useState(new Date());

  const navigate = useNavigate();
  const [isModalExit, setIsModalExit] = useState(false);;

  // Компании, контакты

  const [companyList, setCompanyList] = useState([])
  const [contactList, setContactList] = useState([])
  const [contactPage, setContactPage] = useState(1);
  const [companyPage, setCompanyPage] = useState(1);
  const [contactQuery, setContactQuery] = useState('');
  const [companyQuery, setCompanyQuery] = useState('');
  const [selectedCompany, setSelectedCompany] = useState([])
  const [selectedContact, setSelectedContact] = useState([])

  const currentCompanyList = companyList?.map((el) => ({
    ...el,
    value: el?.id,
    label: el?.name,
  }))

  const currentContactList = contactList?.map((el) => ({
    ...el,
    value: el?.id,
    label: el?.first_name + (el?.last_name ? ` ${el?.last_name}` : '') + (el?.patronymic ? ` ${el?.patronymic}` : '') + (el?.company ? ` (${el?.company})` : ''),
  }))

  const reset = () => {
    setTitle('');
    setInitialDescription('');
    setDescription('');
    setAuthorName('');
    setAuthorColor('');
    setAuthorEmail('');
    setStatusTask([]);
    setSelectedStatusTask({});
    setSelectedProject(null);
    setSelectedPriority({});
    setFiles([]);
    setFilesData([]);
    setEventId(null);
  };

  const [title, setTitle] = useState('');
  const [sum, setSum] = useState(0)
  const [description, setDescription] = useState('');
  const [initialDescription, setInitialDescription] = useState('');
  const [authorName, setAuthorName] = useState('');
  const [authorColor, setAuthorColor] = useState('');
  const [authorEmail, setAuthorEmail] = useState('');
  const [authorId, setAuthorId] = useState(null);
  const [addTaskId, setAddTaskId] = useState();
  const [taskBordId, setTaskBordId] = useState(null)
  const [createdAtTask, setCreatedAtTask] = useState(null)
  const [updatedAtTask, setUpdatedAtTask] = useState(null)
  const [executors, setExecutors] = useState([]);
  const [coExecutors, setCoExecutors] = useState([]);
  const [executorOptions, setExecutorOptions] = useState(attendees)

  const [isLoadingMainInfo, setIsLoadingMainInfo] = useState(true)

  // Новая логика комментариев
  const [chatId, setChatId] = useState(null)

  const [statusTask, setStatusTask] = useState([]);
  const [selectedStatusTask, setSelectedStatusTask] = useState({});
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedFunnel, setSelectedFunnel] = useState(null);
  const [selectedPriority, setSelectedPriority] = useState({
    label: 'Не указано',
    value: 'Не назначено',
  });
  const [isDropMenu, setIstDropMenu] = useState(false);
  const [check, setCheck] = useState(false);
  const [logsArr, setLogsArr] = useState([]);
  const [files, setFiles] = useState([]);
  const [filesdata, setFilesData] = useState([]);
  const [filesdataComments, setFilesDataComments] = useState([]);


  const [saveFile, setSaveFile] = useState(null);
  const [saveFileComment, setSaveFileComment] = useState([]);

  const [eventId, setEventId] = useState(event_id);

  const [currentTab2, setCurrentTab2] = useState(btns_2?.[0]?.value);

  const [idTable, setIdTable] = useState('');
  const [isLodingIdTable, setIsLodingIdTable] = useState(true)
  const [isSave, setIsSave] = useState(null);
  const [isPrint, setIsPrint] = useState(false);

  // Является ли участник чата исполнителем, соисполнителем, автором
  const isMemberChat = () => {
    const cur_executors = executors?.map(({ id }) => id)
    const cur_co_executors = coExecutors?.map(({ id }) => id)

    if (cur_executors?.includes(client_id) || cur_co_executors?.includes(client_id) || (authorId == client_id)) {
      return true
    } else return false
  }

  // Первоначальная загрузка
  const [initLoadExecutor, setInitLoaderExecutor] = useState(true);
  const [initLoadCoExecutor, setInitLoaderCoExecutor] = useState(true);
  const [initLoadDate, setInitLoaderDate] = useState(true);

  // Поля
  const [fields, setFilds] = useState([]);


  // Создание сделки
  // для всех
  const fetchCreateCRM = () => {
    let url = ` https://portals.ecomru.ru/api/crm/deals/`
    if (ticket) {
      url = ` https://portals.ecomru.ru/api/ticket/ticket/`
    }
    if (task) {
      url = `${RavshanHttps}/api/v3/tasks/create_event`
    }

    const priority = task ? { priority: selectedPriority?.value } : {}

    // для задач
    const selCol = allColumns?.filter(
      ({ label }) => label === selectedColumn?.typeName
    )?.[0];
    const task_type =
      +taskId !== -1 ? { task_type: selectedColumn?.typeId } : {};

    const body = JSON.stringify({
      ...task_type, // для задач
      task_id: selectedProject?.value.id,
      [task ? 'task_id' : 'step_id']: task ? (+taskId === -1 ? selCol?.value?.id.toString() : taskId) : selectedColumn?.id,
      ...priority
    });

    fetch(url, { body, method: 'POST', headers })
      .then(res => {
        if (res.status === 409) {
          addErrorPush('Лимиты по тарифу исчерпаны')
          if (crm) {
            navigate('/crm/project-for-crm/project')
          }
          if (ticket) {
            navigate('/ticket/project-for-ticket/project')
          }
          if (task) {
            navigate('/tasks/project-for-tasks')
          }
        }
        if (!res?.ok) {
          throw new Error('bad response')
        }
        return res.json()
      })
      .then((json) => {
        if (typeof json === 'number') {
          setEventId(json);
        }
      })
      .catch((err) => console.error(err));
  };

  // Проверить
  useEffect(() => {
    if (eventId && !isModalCompany && !isModalContact) {
      setTimeout(() => {
        fetchGetTaskInfo()
        fetchGetChatId()
      }, 1000)
    }

    if (eventId) {
      if (crm) {
        fetchGetContacts()
        fetchGetCompany()
      }

      if (crm || task) {
        fetchGetFiles('description');
      }
      // fetchGetProject()
      fetchGetTaskListId();
      setTimeout(() => fetchGetTaskListId(), 4000)

      if (!task) {
        fetchGetCoExecutor();
      }
    }
  }, [eventId, isModalCompany, isModalContact]);

  useEffect(() => {
    if (currentTab2 == 'task-list') {
      fetchGetTaskListId();

    }

    if (eventId) {
      if ((currentTab2 == 'history') && (crm || task)) {
        fetchGetEventLog();
      }

      if ((currentTab2 == 'file') && crm) {
        fetchGetFiles('description');
      }
    }
  }, [currentTab2]);

  const [initIdCol, setInitIdCol] = useState(null)

  // Получение колонок
  const fetchAllColumns = () => {
    if (!taskBordId && task) return

    let url = `https://portals.ecomru.ru/api/crm/deals/steps/${eventId}`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/ticket/steps/${eventId}`
    }
    if (task) {
      url = 'https://portals.ecomru.ru/api/v3/tasks/get_task_type'
    }

    const selCol = allColumns?.filter(({ label }) => label === selectedColumn?.typeName)?.[0];

    const body = JSON.stringify({
      project_id: selectedProject?.value,
      task_board_id: taskBordId
    });

    fetch(url, { method: task ? 'POST' : 'GET', headers, body: task ? body : undefined })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('bad columns response');
        }
      })
      .then((json) => {
        if (!Array.isArray(json)) return;
        setStatusTask(json?.map((el) => ({
          label: el?.name || el?.type_name,
          value: el?.id || el?.type_id,
        })))
      });
  };

  // Получение соисполнителя
  // crm и тикет
  const fetchGetCoExecutor = (filter) => {
    let url = ` https://portals.ecomru.ru/api/crm/deals/co_executors/${eventId}`
    if (ticket) {
      url = ` https://portals.ecomru.ru/api/ticket/ticket/co_executors/${eventId}`
    }

    fetch(url, { method: 'GET', headers })
      .then((res) => res.json())
      .then((json) => {
        const new_coExecutors = json.map((el) => {
          let elem = el;
          elem.email = elem?.login;
          return elem;
        });
        setCoExecutors(new_coExecutors);
      })
      .catch((err) => console.error(err))
  };

  // получение chatId для чатов
  const fetchGetChatId = (filter) => {
    let url = `https://portals.ecomru.ru/api/crm/deals/${eventId}/chat_id`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/ticket/${eventId}/chat_id`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/get_chat_id/${eventId}`
    }

    fetch(url, { method: 'GET', headers })
      .then((res) => res.json())
      .then((json) => {
        if (json) {
          if (ticket) {
            setChatId(json?.chat_id);
          } else {
            setChatId(json);
          }
        } else {
          // Только если нет chatId, пробуем еще раз через 2 секунды
          if (!chatId) {
            setTimeout(() => fetchGetChatId(), 2000);
          }
        }
      })
      .catch((err) => console.error(err));
  };

  // Получение id таск сделки
  // для всех
  const fetchGetTaskListId = (filter) => {
    let url = `https://portals.ecomru.ru/api/crm/deals/${eventId}/task_list_id`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/ticket/${eventId}/task_list_id`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/get_task_list_id/${eventId}`;
    }

    fetch(url, { method: 'GET', headers })
      .then((res) => res.json())
      .then((json) => {
        setIdTable(json);
        setIsLodingIdTable(false)
      })
      .catch((err) => console.error(err));
  };

  // Изменение приоритета
  // для всех
  const fetchSetPriority = (selected) => {
    setIsSave(false);
    let url = `https://portals.ecomru.ru/api/crm/deals/priority`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/ticket/priority`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/set_priority`
    }

    const body_curr = JSON.stringify({
      [cur_param_id()]: eventId,
      priority: selectedPriority?.value,
    });

    fetch(url, { body: body_curr, method: task ? 'POST' : 'PATCH', headers })
      .then((res) => res.json())
      .then((json) => {
        update();
        setIsSave(true);
      })
      .catch((err) => console.error(err));
  };

  // Изменение соисполнителя
  // для всех
  const fetchSetCoExecutor = (selected) => {
    setIsSave(false);
    let url = `https://portals.ecomru.ru/api/crm/deals/add_co_executor`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/ticket/add_co_executor`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/set_co_executors`
    }

    const current_list_selected = coExecutors?.map(({id}) => id)

    const body_curr = JSON.stringify({
      [cur_param_id()]: eventId,
      [`co_executor${task ? 's' : ''}`]: task ? [...current_list_selected, selected] : selected,
    });

    fetch(url, { body: body_curr, method: task ? 'POST' : 'PATCH', headers })
      .then((res) => res.json())
      .then((json) => {
        update();
        setIsSave(true);
      })
      .catch((err) => console.error(err));
  };

  // удаление соисполнителя
  const fetchDeleteCoExecutor = (selected) => {
    setIsSave(false);
    let url = `https://portals.ecomru.ru/api/crm/deals/remove_co_executor`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/deals/remove_co_executor`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/remove_co_executor`
    }

    const body_curr = JSON.stringify({
      [cur_param_id()]: eventId,
      co_executor: selected,
    });

    fetch(url, { body: body_curr, method: task ? 'POST' : 'PATCH', headers })
      .then((res) => res.json())
      .then((json) => {
        update();
        setIsSave(true);
      })
      .catch((err) => console.error(err));
  };

  // Изменение даты дедлайн
  // для всех
  const fetchSetDates = () => {
    setIsSave(false);
    let url = `https://portals.ecomru.ru/api/crm/deals/deadline`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/ticket/deadline`
    }
    if (task) {
      url = 'https://portals.ecomru.ru/api/v3/tasks/set_end_time'
    }

    const body_curr = JSON.stringify({
      [cur_param_id()]: eventId,
      [task ? 'end_time' : 'deadline']: endDate
    });

    fetch(url, { body: body_curr, method: task ? 'POST' : 'PATCH', headers })
      .then((res) => res.json())
      .then((json) => {
        update();
        setIsSave(true);
      })
      .catch((err) => console.error(err));
  };

  // Изменение даты клиента
  // для всех
  const fetchSetDatesClient = () => {
    setIsSave(false);
    let url = `https://portals.ecomru.ru/api/crm/deals/client_date`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/ticket/client_date`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/set_employee_time`
    }

    const body_curr = JSON.stringify({
      [cur_param_id()]: eventId,
      [task ? 'employee_time' : 'client_date']: endDate2
    });

    fetch(url, { body: body_curr, method: task ? 'POST' : 'PATCH', headers })
      .then((res) => res.json())
      .then((json) => {
        update();
        setIsSave(true);
      })
      .catch((err) => console.error(err));
  };

  // Получение сделки по id
  // для всех
  const fetchGetTaskInfo = () => {
    setIsLoadingMainInfo(true)

    let url = `https://portals.ecomru.ru/api/crm/deals/${eventId}`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/ticket/${eventId}`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/event/${eventId}`
    }

    fetch(url, { method: 'GET', headers })
      .then((res) => res.json())
      .then((json) => {

        const {
          id,
          // задачи
          date,
          text,
          rating,
          chat_id,
          end_time,
          project,
          task_type,
          start_time,
          task_board,
          executor,
          co_executors,
          employee_time,

          created_at,
          updated_at,

          sum,
          name,
          files,
          author,
          company,
          contacts,
          description,
          deadline,
          responsible,
          funnel,
          step,
          priority,
          task_list_id,
          client_date
        } = json;

        // Задачи 
        if (created_at) {
          setCreatedAtTask(new Date(created_at).toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: 'numeric',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          }))
        }

        if (updated_at) {
          setUpdatedAtTask(new Date(updated_at).toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: 'numeric',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          }))
        }
        if (co_executors) {
          const new_coExecutors = co_executors.map((el) => {
            let elem = el;
            elem.email = elem?.login;
            return elem;
          });
          setCoExecutors(new_coExecutors);
        }
        if (executor) {
          setExecutors([executor]);
        }
        if (task_type) {
          setSelectedStatusTask({ label: task_type?.name, value: task_type?.id })
          setInitIdCol(task_type?.id)
        }
        if (task_board?.id) {
          setSelectedFunnel({
            value: task_board?.id,
            label: task_board?.name
          });
          setTaskBordId(task_board?.id)
        }
        if (project) {
          setSelectedProject({
            label: project.name,
            value: project.id,
          })
        }
        if (end_time) {
          setEndDate(new Date(convertDate(end_time)));
        }
        if (employee_time) {
          setEndDate2(new Date(convertDate(employee_time)));
        }
        // if (chat_id) {
        //   setChatId(chat_id)
        // }
        if (text) {
          setDescription(text)
        }
        if (name) {
          setTitle(name)
        }
        if (description) {
          setDescription(description)
        }
        if (deadline) {
          setEndDate(new Date(deadline));
        }
        if (client_date) {
          setEndDate2(new Date(client_date));
        }
        setSum(sum?.toString())
        if (company) {
          setSelectedCompany({
            ...company,
            label: company?.name,
            value: company?.id
          })
        }
        if (responsible?.id) {
          setExecutors([responsible]);
        }
        if (priority) {
          const priorityToDropdown = OPTIONS_PRIORITY.find(
            (p) => p.value === priority
          );
          setSelectedPriority(priorityToDropdown ?? OPTIONS_PRIORITY.at(-1));
          const selProjId = isNew ? selectedProject?.value?.id : selectedProject?.value;
          setUpdateId(taskId === '-1' ? selProjId : selectedStatusTask?.value)
        }

        if (funnel?.id) {
          setSelectedFunnel({
            value: funnel?.id,
            label: funnel?.name
          });
        }
        if (contacts?.length) {
          const current_list = contacts.map((el) => {
            return {
              ...el,
              value: el?.id,
              label: el?.first_name + (el?.last_name ? ` ${el?.last_name}` : '') + (el?.patronymic ? ` ${el?.patronymic}` : '') + (el?.company ? ` (${el?.company})` : ''),
            }
          })
          setSelectedContact(current_list)
        }
        if (step) {
          setSelectedStatusTask({ label: step?.name, value: step?.id })
          setInitIdCol(step?.id)
        }
        if (author) {
          setAuthorColor(author?.color)
          setAuthorEmail(author?.login)
          setAuthorName(author?.name)
          setAuthorId(author?.id)
        }
        if (Array.isArray(files) && files?.length) {
          const curr_files = files?.map((el) => {
            return {
              created_at: el?.created_at,
              file_size_kb: (el?.file_size_kb).toString(),
              new_filename: el?.label,
              url: el?.url,
              extension: el?.extension,
              file_id: el?.id
            };
          });
          setFilesData(curr_files);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setIsLoadingMainInfo(false))
  };

  // Получить доступные компании
  const fetchGetCompany = () => {
    let url = ` https://portals.ecomru.ru/api/crm/companies/?page=${companyPage}&limit=50&search=${companyQuery}`

    fetch(url, { method: 'GET', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        if (json?.data && Array.isArray(json?.data)) {
          if (companyPage > 1) {
            setCompanyList((prev) => [...prev, ...json?.data]);
          } else {
            setCompanyList([...json?.data]);
          }
        }
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (crm) {
      fetchGetCompany();
    }
  }, [companyPage, companyQuery]);

  // Получить доступные контакты
  const fetchGetContacts = () => {
    let url = ` https://portals.ecomru.ru/api/crm/contacts/?page=${contactPage}&limit=50&search=${contactQuery}`;

    fetch(url, { method: 'GET', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        if (json?.data && Array.isArray(json?.data)) {
          if (contactPage > 1) {
            setContactList((prev) => [...prev, ...json?.data]);
          } else {
            setContactList([...json?.data]);
          }
        }
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (crm) {
      fetchGetContacts();
    }
  }, [contactPage, contactQuery]);

  // Получить участников проекта 
  // для всех
  const fetchPossibleAttendees = () => {
    let url = `https://portals.ecomru.ru/api/crm/projects/${taskId}/attendees?can_be_add=false`;
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/project/${taskId}/attendees?can_be_add=false`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/tasks/project_client_team`
    }

    const newHeaders = {
      ...headers,
      'project-id': addTaskId,
    };

    fetch(url, { headers: newHeaders })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('bad attendees response');
        }
      })
      .then((json) => {
        setExecutorOptions(json);
      })
      .catch((e) => console.error(e));
  };

  // Получение истории сделки
  // для задач и срм
  const fetchGetEventLog = (filter) => {
    let url = `https://portals.ecomru.ru/api/crm/deals/history`
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/get_event_log`
    }

    const body_curr = JSON.stringify({
      limit: 1000,
      page: 1,
      [cur_param_id()]: eventId,
    });

    fetch(url, { body: body_curr, method: 'POST', headers })
      .then((res) => res.json())
      .then((json) => {
        if (Array.isArray(json)) {
          setLogsArr(json);
        }
      })
      .catch((err) => console.error(err));
  };

  // Добавить имя сделки
  // для всех
  const fetchSetName = () => {
    setIsSave(false);
    let url = `https://portals.ecomru.ru/api/crm/deals/name`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/ticket/name`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/set_name`
    }

    const body = JSON.stringify({
      [cur_param_id()]: eventId,
      name: title,
    });

    fetch(url, { body, method: task ? 'POST' : 'PATCH', headers })
      .then((res) => res.json())
      .then((json) => {
        update();
        setIsSave(true);
      })
      .catch((err) => console.error(err));
  };

  // Добавить описание сделки
  // для всех
  const fetchSetDescription = () => {

    if (initialDescription.replaceAll('</a>', ' </a> ').replaceAll(' <a', ' <a ') !== description) {
      setIsSave(false);
      let url = `https://portals.ecomru.ru/api/crm/deals/description`
      if (ticket) {
        url = `https://portals.ecomru.ru/api/ticket/ticket/description`
      }
      if (task) {
        url = `https://portals.ecomru.ru/api/v3/tasks/set_text`
      }

      const body = JSON.stringify({
        [cur_param_id()]: eventId,
        [task ? 'text' : 'description']: description?.replace(/<[^>]*>/g, '').trim() ? description : '',
      });

      fetch(url, { body, method: task ? 'POST' : 'PATCH', headers })
        .then((res) => res.json())
        .then((json) => {
          update();
          setInitialDescription(description.replaceAll('</a>', ' </a> ').replaceAll('<a', ' <a'));
          setIsSave(true);
        })
        .catch((err) => console.error(err));
    }
  };

  // Добавить сумму сделки
  // для срм
  const fetchSetSum = () => {
    setIsSave(false);
    let url = ` https://portals.ecomru.ru/api/crm/deals/sum`

    const body = JSON.stringify({
      deal_id: eventId,
      sum: sum,
    });

    fetch(url, { body, method: 'PATCH', headers })
      .then((res) => res.json())
      .then((json) => {
        update();
        setIsSave(true);
      })
      .catch((err) => console.error(err));
  };

  // Добавить ответственного
  // для всех
  const fetchSetExecutor = (selected) => {
    setIsSave(false);
    let url = `https://portals.ecomru.ru/api/crm/deals/responsible`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/ticket/responsible`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/set_executor`
    }

    const body_curr = JSON.stringify({
      [cur_param_id()]: eventId,
      [task ? 'executor' : 'responsible']: selected || null
    });

    fetch(url, { body: body_curr, method: task ? 'POST' : 'PATCH', headers })
      .then((res) => res.json())
      .then((json) => {
        update();
        setIsSave(true);
      })
      .catch((err) => console.error(err));
  };

  // Добавить компанию
  // для crm
  const fetchSetCompany = () => {
    setIsSave(false);
    let url = ` https://portals.ecomru.ru/api/crm/deals/company`

    const body = JSON.stringify({
      deal_id: eventId,
      company_id: selectedCompany?.value
    });

    fetch(url, { body, method: 'PATCH', headers })
      .then((res) => res.json())
      .then((json) => {
        if (json == 'Deal company was changed') {
          update();
          setIsSave(true);
        }
      })
      .catch((err) => console.error(err));
  };

  // Добавить контакт
  // для crm
  const fetchSetContact = (contact_id) => {
    setIsSave(false);
    let url = ` https://portals.ecomru.ru/api/crm/deals/contact/add`

    const body = JSON.stringify({
      deal_id: eventId,
      contact_id
    });

    fetch(url, { body, method: 'POST', headers })
      .then((res) => res.json())
      .then((json) => {
        update();
        setIsSave(true);
      })
      .catch((err) => console.error(err));
  };

  // Изменение статуса сделки
  // для всех
  const fetchSetTaskType = () => {

    setIsSave(false);
    let url = `https://portals.ecomru.ru/api/crm/deals/step/{deal_id}`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/ticket/step`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/set_task_type`;
    }

    const body = JSON.stringify({
      [cur_param_id()]: eventId,
      [task ? 'task_type' : 'step_id']: selectedStatusTask?.value,
    });

    fetch(url, { body, method: task ? 'POST' : 'PATCH', headers })
      .then((res) => res.json())
      .then((json) => {
        update();
        setIsSave(true);
      })
      .catch((err) => console.error(err));
  };

  // добавление файла
  // не готово
  const fetchAddFiles = (filesdata, type, id_comment) => {
    if (saveFile || saveFileComment) {
      setIsSave(false);
      let url = `https://portals.ecomru.ru/api/crm/deals/file/add`
      if (task) {
        url = `https://portals.ecomru.ru/api/v3/tasks/add_files`
      }

      const filesDataCurr = saveFile?.map(
        ({ url, file_size_kb, extension, new_filename }) => {
          return {
            url: url,
            file_size_kb: file_size_kb.toString(),
            extension,
            new_filename
          };
        }
      );

      const body_files = JSON.stringify({
        [cur_param_id()]: eventId,
        url: saveFile?.[0]?.url,
        file_size_kb: saveFile?.[0]?.file_size_kb.toString(),
        extension: saveFile?.[0]?.extension,
        new_filename: saveFile?.[0]?.new_filename,
        files: filesDataCurr,
        place: type, // для задач
      });

      fetch(url, { body: body_files, method: 'POST', headers })
        .then((res) => res.json())
        .then((json) => {
          setSaveFile([]);
          fetchGetFiles(type);
          update();
          setIsSave(true);
        })
        .catch((err) => console.error(err));
    }
  };

  // Получение проекта по сделке
  // crm и тикет, по задачам в общей инфе
  const fetchGetProject = (filter) => {
    let url = ` https://portals.ecomru.ru/api/crm/deals/project/${eventId}`
    if (ticket) {
      url = ` https://portals.ecomru.ru/api/ticket/ticket/project/${eventId}`
    }

    fetch(url, { method: 'GET', headers })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('bad columns response');
        }
      })
      .then((json) => {
        if ((json?.id && json?.name)) {
          setSelectedProject({
            label: json.name,
            value: json.id,
          })
        }
      });

  };

  // получение файлов
  // для задач и срм
  const fetchGetFiles = (filter) => {
    let url = ` https://portals.ecomru.ru/api/crm/deals/file/get/${eventId}`
    if (task) {
      url = `${RavshanHttps}/api/v3/tasks/get_event_files?event_id=${eventId}&filter=${filter}`;
    }

    fetch(url, { method: 'GET', headers })
      .then((res) => res.json())
      .then((json) => {
        // в ответ файлы по фильтру
        const curr_files = json?.map((el) => {
          return {
            created_at: el?.created_at,
            file_size_kb: (el?.file_size_kb).toString(),
            new_filename: el?.name || el?.label,
            url: el?.url,
            extension: el?.extension,
            file_id: el?.id
          };
        });
        if (filter == 'description') {
          setFilesData(curr_files);
        } else {
          setFilesDataComments(curr_files);
        }
      })
      .catch((err) => console.error(err));
  };

  // Удаление файлов
  // для crm и задач
  const fetchDeleteFiles = (event_id, url_file, type, file_id) => {
    setIsSave(false);
    let url = `https://portals.ecomru.ru/api/crm/deals/file/remove`
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/delete_file`;
    }

    const body_files = JSON.stringify({
      [cur_param_id()]: event_id,
      [task ? 'file_url' : 'url']: url_file,
      place: type, // "comment"
      file_id: file_id,
    });

    fetch(url, { body: body_files, method: 'DELETE', headers })
      .then((res) => res.json())
      .then((json) => {
        update();
        setIsSave(true);
      })

      .catch((err) => console.error(err));
  };

  // Удалить контакт
  // для crm
  const fetchDeleteContact = (contact_id) => {
    setIsSave(false);
    let url = ` https://portals.ecomru.ru/api/crm/deals/contact/remove`

    const body = JSON.stringify({
      deal_id: eventId,
      contact_id
    });

    fetch(url, { body, method: 'DELETE', headers })
      .then((res) => res.json())
      .then((json) => {
        update();
        setIsSave(true);
      })
      .catch((err) => console.error(err));
  };

  // Получение полей
  const fetchGetAdditionalFields = (abortController = new AbortController()) => {
    let url = `https://portals.ecomru.ru/api/crm/deals/additional_fields/${eventId}`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/ticket/additional_fields/${eventId}`
    }
    if (task) {
      url = `https://portals.ecomru.ru:4447/api/v3/tasks/additional_fields/${eventId}`
    }

    const selCol = allColumns?.filter(
      ({ label }) => label === selectedColumn?.typeName
    )?.[0];

    const body = JSON.stringify({
      task_id: taskId === '-1' ? +selCol?.value?.id : +taskId,
      event_id: +eventId,
    });

    fetch(url, { headers })
      .then((res) => res.json())
      .then((json) => {
        const list = json.map(({ name, id, type, value, possible_values, field_source, field_id, field_name }) => {
          return {
            front_name: name || field_name,
            data_type: type,
            id: id || field_id,
            value: (type == 'bool' || value === 'null') ? JSON.parse(value) : value,
            possible_values: possible_values,
            field_source: field_source,
            field_name
          };
        });

        setFilds(list)
      })
      .catch((err) => console.error(err));
  };

  // Запись полей
  const fetchSetValueField = (id, value, field_source, field_name) => {
    let url = `https://portals.ecomru.ru/api/crm/deals/additional_fields/${eventId}`
    if (ticket) {
      url = `https://portals.ecomru.ru/api/ticket/ticket/additional_fields/${eventId}`
    }
    if (task) {
      url = `https://portals.ecomru.ru/api/v3/tasks/set_additional_fields`
    }

    const body = JSON.stringify({
      [cur_param_id()]: eventId,
      field_id: id,
      value: (typeof value == 'string' || Array.isArray(value)) ? value : JSON.stringify(value),
      field_source,
      field_name, // для задач
    })

    fetch(url, { method: 'POST', headers, body })
      .then((res) => res.json())
      .then(() => {})
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (isNew) {
      fetchCreateCRM();
    }
  }, []);

  useEffect(() => {
    if (eventId) {
      fetchGetAdditionalFields();
    }
  }, [eventId]);


  const btns = [
    {
      btn: 'Удалить',
      func: (e) => {
        const selProjId = isNew ? selectedProject?.value?.id : selectedProject?.value;
        fetchDeleteTask(eventId, true);
        setUpdateId(taskId == -1 ? selProjId : selectedStatusTask?.value)
        handleCloseModal()
        setTasks([]);
        setIsModal(false);
        setInfoTask(null);
        setIstDropMenu(false);
      },
    },
  ];

  useEffect(() => {
    if (saveFile?.length > 0) {
      fetchAddFiles(filesdata, 'description');
      const timeoutId = setTimeout(() => {
        fetchGetFiles('description');
        if ((currentTab2 == 'history') && (crm || task)) {
          fetchGetEventLog();
        }
      }, 500);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [saveFile]);

  useEffect(() => {
    if (saveFileComment?.length > 0) {
      const timeoutId = setTimeout(() => {
        fetchGetFiles('comments');
        if ((currentTab2 == 'history') && (crm || task)) {
          fetchGetEventLog();
        }
      }, 500);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [saveFileComment]);

  const update = () => {
    if ((currentTab2 == 'history') && (crm || task)) {
      fetchGetEventLog();
    }
  };

  useEffect(() => {
    const selProjId = selectedProject?.id
    fetchAllColumns(0, selProjId);
  }, [selectedProject, selectedColumn, allColumns, taskBordId]);

  useEffect(() => {
    const selProjId = selectedProject?.value;
    if (!infoTask?.id) {

      if (+taskId === -1) {
        const selCol = allColumns?.filter(
          ({ label }) => label === selectedColumn?.typeName
        )?.[0];
        setAddTaskId(selProjId ? selProjId : selCol?.value?.id);
        setSelectedProject(selCol);
      } else {
        const selCol = allColumns?.filter(
          ({ value: { id } }) => id === +taskId
        )?.[0];
        setAddTaskId(taskId);
        setSelectedProject(selCol);
      }
    } else {
      setAddTaskId(selProjId);
    }
  }, [selectedProject, selectedColumn, allColumns, selectedSpace, taskBordId]);

  function replaceString(oldS, newS, fullS) {
    return fullS.split(oldS).join(newS);
  }

  const current_file_list = () => {
    const extensions = ['jpg', 'jpeg', 'tiff', 'raw', 'bmp', 'psd'];
    let list_files_img;
    let list_files_file;

    list_files_img = filesdata.filter((el) =>
      extensions?.includes(el?.extension)
    );
    list_files_file = filesdata.filter(
      (el) => !extensions?.includes(el?.extension)
    );
    return filesdata;
  };

  useEffect(() => {
    if (!initLoadExecutor) {
      if (Array.isArray(executors)) {
        fetchSetExecutor(executors[0]?.id ? executors[0]?.id : null);
      }
    }
  }, [executors]);

  useEffect(() => {
    if (!initLoadDate) {
      fetchSetDates();
      setInitLoaderDate(false);
    }
  }, [endDate]);

  useEffect(() => {
    if (!initLoadDate) {
      fetchSetDatesClient()
      setInitLoaderDate(false);
    }
  }, [endDate2]);

  const handleCloseModal = () => {
    // Проверка на незаполненные поля
    if (!selectedStatusTask?.value || !title && ((email == authorEmail) || ticket)) {
      setIsModalExit(true);
      return;
    }

    // Навигация 
    if (crm) {
      sessionStorage.removeItem('crmId');
      navigate(`/crm/crm-list/${taskId}${query ? `&${query}` : ''}`);
    }
    if (ticket) {
      sessionStorage.removeItem('ticketId');
      navigate(`/ticket/ticket-list/${taskId}${query ? `&${query}` : ''}`);
    }
    if (task) {
      sessionStorage.removeItem('eventId');
      navigate(`/tasks/task-list/${taskId}${query ? `&${query}` : ''}`);
    }

    // Обновление ID колонки при создании или изменении задачи
    const selProjId = isNew ? selectedProject?.value : selectedProject?.value;
    const currentId = taskId === '-1' ? selProjId : selectedStatusTask?.value;

    if (initIdCol !== currentId || isNew) {
      setActualId(initIdCol);
      if (initIdCol !== selectedStatusTask?.value) {
        setUpdateId(currentId);
      }
    }

    // Сброс и закрытие
    setIsNew(false);
    reset();
    setIsModal(false);
  };

  return (
    <>
      {isPrint &&
        <PrintableVersion
          title={title}
          description={description}
          eventId={eventId}
          selectedStatusTask={selectedStatusTask}
          selectedPriority={selectedPriority}
          executors={executors}
          coExecutors={coExecutors}
          selectedProject={selectedProject}
          endDate2={endDate2}
          setIsPrint={setIsPrint}
        />
      }

      {isModalExit &&
        <ModalAddTaskExit
          setIsModal={setIsModalExit}
          setIsModalClose={setIsModal}
          fetchDeleteTask={fetchDeleteTask}
          eventId={eventId}
          setIsNew={setIsNew}
          update={handleCloseModal}
        />
      }

      <div
        className="blackout"
        onClick={(e) => {
          let el = e.target;
          if (el.classList.contains('blackout')) {
            handleCloseModal()
          }
        }}
      >
        <div className="modal-add-task">
          <div className="modal-add-task__chat">
            <div className="modal-add-task__header modal-add-task__header-comment" >
              <TabsGreen
                btns={btns_2}
                currentBtn={currentTab2}
                setCurrentBtn={setCurrentTab2}
                checkValue={true}
              />
            </div>

            <div className="modal-add-task__comment-container">

              {/* Комментарии */}

              <div className={currentTab2 === 'comment' ? "modal-add-task__list-message" : "modal-add-task__list"}>

                {(currentTab2 === 'comment') &&
                  ((isMemberChat() && chatId && (authorId || client_id)) ?
                    <ChatComment
                      chatId={chatId}
                      authorId={authorId || client_id}
                    />
                    :
                    <NoDataContent
                      height='100%'
                      title={'Чат не доступен'}
                      description={'Чат доступен только автору, ответственному или соисполнителю'}
                      border={false}
                    />
                  )
                }

                {/* История */}

                {currentTab2 === 'history' &&
                  <HistoryTask
                    logsArr={logsArr}
                  />
                }

                {/* Файлы */}

                {currentTab2 == 'file' &&
                  <>{current_file_list()?.length > 0 ?
                    current_file_list()?.map(({
                      created_at,
                      file_size_kb,
                      new_filename,
                      url
                    }, ind) => {
                      return <FileItemComponent
                        key={ind + url}
                        isDelete={false}
                        type={'description'}
                        eventId={eventId}
                        fetchDeleteFiles={fetchDeleteFiles}
                        fetchGetFiles={fetchGetFiles}
                        created_at={created_at}
                        file_size_kb={file_size_kb}
                        new_filename={new_filename}
                        url={url}
                        authorEmail={authorEmail}
                        filesdata={filesdata}
                        setFilesData={(e) => setFilesData(e)}
                        saveFile={saveFile}
                        setSaveFile={setSaveFile}
                      />
                    })
                    :
                    <NoDataContent
                      height='100%'
                      title={'Ничего не найдено'}
                      description={' Прикрепите изображение, файл, видео в комментариях, описании или нажмите на кнопку выше'}
                      border={false}
                    />
                  }</>
                }

                {/* Подзадачи */}

                {currentTab2 == 'task-list' &&
                  <CheckList
                    loading={isLodingIdTable}
                    update={fetchGetChatId}
                    idTable={idTable}
                    authorEmail={authorEmail || email}
                  />
                }
              </div>
            </div>
          </div>

          <div className="modal-add-task__right-content">
            <div
              className="modal-add-task__header"
              style={{ minHeight: '58px' }}
            >
              {!isLoadingMainInfo ? (
                <>
                  <div className="modal-add-task__header-left-box">
                    <h1
                      className="modal-add-task__task-id"
                      onClick={() => {
                        if (eventId) {
                          navigator.clipboard.writeText(`https://lk.ecomru.ru` + window.location.pathname);
                        }
                      }}
                    >
                      {isLoadInfoTask
                        ? 'Загрузка...'
                        : eventId && (
                          <>
                            <ButtonCopy
                              value={eventId}
                              style={{ position: 'static' }}
                              icon={copy_icon}
                            />
                            {`ID${eventId}`}
                          </>
                        )}
                    </h1>

                    <div className='modal-add-task__project-info'>
                      {selectedProject?.label} <img src={drop_icon} alt='icon' /> {selectedFunnel?.label} <img src={drop_icon} alt='icon' /> {selectedStatusTask?.label}
                    </div>


                    {/* <DropDownSelector
                      options_prop={allColumns}
                      placeholder="Проект"
                      state={selectedProject}
                      setState={(e) => setSelectedProject(e)}
                      disabled={infoTask?.id}
                      maxWidth='180px'
                    />

                    <DropDownSelector
                      options_prop={allColumns}
                      placeholder={task ? "Доска" : "Воронка"}
                      state={selectedFunnel}
                      setState={(e) => setSelectedFunnel(e)}
                      disabled={infoTask?.id}
                      maxWidth='180px'
                    /> */}
                  </div>

                  {isSave !== null && <SaveIndicator
                    isSave={isSave}
                  />}

                  <ButtonWithIcon
                    whiteGreen
                    size='m'
                    minWidth="40px"
                    width="40px"
                    icon={print_icon}
                    onClick={() => setIsPrint(true)}
                    style={{
                      marginLeft: 'auto',
                    }}
                  />

                  {((email == authorEmail) || ticket) &&
                    <ButtonActionDrop
                      id={1}
                      btns={btns}
                    />}

                  <ButtonClose
                    m
                    onClick={handleCloseModal}
                  />
                </>
              ) :
                <Stack className="sceleton-select-group__content">
                  <Skeleton variant="rectangular" width={400} height={28} />
                </Stack>
              }
            </div>

            <div className="modal-add-task__header">
              {!isLoadingMainInfo ?
                <>
                  <AuthorAvatar
                    size='m'
                    show_name
                    color={authorColor}
                    author={[authorName, authorColor]}
                  />

                  <div
                    onBlur={() => {
                      fetchSetPriority();
                    }}
                  >
                    <DropDownSelector
                      options_prop={OPTIONS_PRIORITY}
                      placeholder="Приоритет"
                      isClearable={false}
                      value={selectedPriority}
                      defaultValue={selectedPriority}
                      state={selectedPriority}
                      setState={setSelectedPriority}
                      maxWidth='180px'
                    />
                  </div>

                  <div
                    onBlur={() => {
                      fetchSetTaskType();
                    }}
                  >
                    <DropDownSelector
                      options_prop={statusTask}
                      placeholder="Статус"
                      isClearable={false}
                      value={selectedStatusTask}
                      defaultValue={selectedStatusTask}
                      state={selectedStatusTask}
                      setState={setSelectedStatusTask}
                      maxWidth='180px'
                    />
                  </div>

                  <div className="select-group">

                    <DateBox
                      onBlur={(e) => {
                        if (initLoadDate) {
                          setInitLoaderDate(false);
                        }
                      }}
                      disabled={check}
                      startDate={endDate}
                      description={'Дедлайн'}
                      setStartDate={setEndDate}
                    />

                    {/* <Checkbox
                      value={check}
                      onChange={(e) => setCheck(e)}
                    >
                      Без срока
                    </Checkbox> */}
                  </div>
                </>
                :
                <div className="sceleton-header">
                  <Stack className="sceleton-header__content">
                    <Skeleton variant="circular" width={40} height={40} />
                    {[...Array(3)].map((el, ind) => {
                      return <Skeleton
                        key={ind}
                        variant="rectangular"
                        width={210}
                        height={40}
                      />
                    })}
                  </Stack>
                </div>
              }
            </div>

            <div className="modal-add-task__content">
              <div className="main-info">
                {!isLoadingMainInfo ? (
                  <>
                    <div
                      onBlur={fetchSetName}
                    >
                      <TitleContentEditable
                        disabled={(authorEmail !== email) && ((executors?.[0]?.email || executors?.[0]?.login) != email)}
                        placeholder="Добавьте название"
                        title={title}
                        setTitle={setTitle}
                      />
                    </div>

                    <Editor
                      onBlur={fetchSetDescription}
                      setSaveFile={setSaveFile}
                      type={'description'}
                      fetchAddFiles={fetchAddFiles}
                      fetchGetFiles={fetchGetFiles}
                      eventId={eventId}
                      filesdata={filesdata}
                      setFiles={setFiles}
                      disabled={(authorEmail !== email) && ((executors?.[0]?.email || executors?.[0]?.login) != email)}
                      bounds=".main-info"
                      title="Описание"
                      placeholder="Редактировать описание сделки"
                      description={description}
                      setDescription={setDescription}
                      setFilesData={setFilesData}
                      authorEmail={authorEmail}
                      hideBtn={true}
                      fetchDeleteFiles={fetchDeleteFiles}
                      saveFile={saveFile}
                      isFile={crm || task}
                    />

                    {/* crm */}

                    {crm ? <>
                      <InputDinamycPlaceholder
                        placeholder={'Сумма сделки'}
                        changeValue={sum}
                        onChange={(e) => setSum(e)}
                        onBlur={() => fetchSetSum()}
                        size="s"
                      />

                      <div className='modal-add-task__company-group'>
                        {/* Компании */}
                        <div className='modal-add-task__company-item'>
                          <div className='modal-add-task__company-header'>
                            <TitlePage
                              medium
                              title='Компания'
                            />

                            <ButtonWithIcon
                              size='xs'
                              icon={add_icon}
                              onClick={(e) => {
                                setCurrentDeal(eventId)
                                setIsModalCompany(true)
                              }}
                            />
                          </div>

                          <DropDownSelector
                            options_prop={currentCompanyList}
                            placeholder="Компания"
                            fetchCallback={setCompanyPage}
                            setInputChange={setCompanyQuery}
                            state={selectedCompany}
                            setState={setSelectedCompany}
                            width='100%'
                            onBlur={fetchSetCompany}
                            preventMenuUpward
                          />

                          {selectedCompany?.value ?
                            <CompanyCard
                              company={selectedCompany}
                            />
                            : null}
                        </div>

                        {/* Контакты */}
                        <div className='modal-add-task__company-item'>
                          <div className='modal-add-task__company-header'>
                            <TitlePage
                              medium
                              title='Контакты'
                            />

                            <ButtonWithIcon
                              size='xs'
                              icon={add_icon}
                              onClick={(e) => {
                                setCurrentDeal(eventId)
                                setIsModalContact(true)
                              }}
                            />
                          </div>

                          <DropDownSelector
                            options_prop={currentContactList}
                            placeholder="Контакт"
                            state={selectedContact}
                            fetchCallback={(e) => setContactPage(e)}
                            setInputChange={(e) => setContactQuery(e)}
                            setState={(e) => {
                              // Определяем, что изменилось
                              const added = e.filter(x => !selectedContact.some(y => y.value === x.value));
                              const removed = selectedContact.filter(x => !e.some(y => y.value === x.value));

                              if (added.length > 0) {
                                fetchSetContact(added[0]?.value);
                              }
                              if (removed.length > 0) {
                                fetchDeleteContact(removed[0]?.value)
                              }
                              setSelectedContact(e);
                            }}
                            multi
                            all={false}
                            preventMenuUpward
                          />

                          {selectedContact?.length ? <div className='modal-add-task__contact-list'>
                            {selectedContact.map((contact, ind) => {
                              return <ContactCard
                                key={contact?.label + ind}
                                contact={contact}
                              />
                            })}
                          </div>
                            : null
                          }
                        </div>
                      </div>
                    </>
                      :
                      null}

                    <DynamicFormComponent
                      productTemporary={fields.map((el) => ({ ...el, id: el?.id || el?.field_id }))}
                      fetchSetValue={fetchSetValueField}
                    />
                  </>
                ) : (
                  <div className="sceleton-main-info">
                    <Stack className="sceleton-main-info__content">
                      <Skeleton variant="rectangular" height={48} />
                      <Skeleton variant="rectangular" width={100} height={16} />
                      <Skeleton variant="rectangular" height={200} />
                    </Stack>
                  </div>
                )}
              </div>

              <div className="additional-information">
                <div className="additional-information__info">
                  <div className="select-group">
                    {!isLoadingMainInfo ?
                      <>
                        {
                          (createdAtTask || updatedAtTask) &&
                          <div className='modal-add-task__date-info'>
                            {createdAtTask && <span>Создано: {createdAtTask} г.
                            </span>}
                            {updatedAtTask && <span>Обновлено: {updatedAtTask} г.
                            </span>}
                          </div>
                        }

                        <div
                          onClick={(e) => {
                            if (initLoadExecutor) {
                              setInitLoaderExecutor(false);
                            }
                          }}
                        >
                          <SelectExecutor
                            executors={executors}
                            setExecutors={(e) => {
                              if (!isNew) {
                                const selProjId = selectedProject?.value;
                                setUpdateId(taskId === '-1' ? selProjId : selectedStatusTask?.value)
                              }
                              setExecutors(e);
                            }}
                            executorOptions={executorOptions}
                            title="Ответственный"
                            placeholder="Назначить"
                          />
                        </div>

                        <div
                          onClick={(e) => {
                            if (initLoadCoExecutor) {
                              setInitLoaderCoExecutor(false);
                            }
                          }}
                        >
                          <SelectExecutor
                            executors={coExecutors}
                            setExecutors={setCoExecutors}
                            executorOptions={executorOptions?.filter(
                              ({ id }) => {
                                if (executors[0]?.id) {
                                  return id != executors[0].id;
                                }
                              }
                            )}
                            onAddExecutor={fetchSetCoExecutor}
                            onDeleteExecutor={fetchDeleteCoExecutor}
                            title="Cоисполнители"
                            placeholder="Назначить"
                            hideTooltip={false}
                            multi
                          />
                        </div>

                        <div className="select-group__date-box">
                          <DateBox
                            onBlur={(e) => {
                              if (initLoadDate) {
                                setInitLoaderDate(false);
                              }
                            }}
                            startDate={endDate2}
                            description={'Срок выполнения'}
                            setStartDate={(e) => {
                              setEndDate2(e);
                            }}
                          />

                          <Checkbox
                            value={
                              new Date(endDate2)?.toLocaleDateString(
                                'ru-RU'
                              ) === new Date()?.toLocaleDateString('ru-RU')
                            }
                            onChange={(e) => setEndDate2(new Date())}
                            disabled={
                              new Date(endDate2)?.toLocaleDateString(
                                'ru-RU'
                              ) === new Date()?.toLocaleDateString('ru-RU')
                            }
                          >
                            Выполню сегодня
                          </Checkbox>
                        </div>

                      </>
                      :
                      <SceletonSelectGroups />
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { ModalAddTask };
